import React from 'react';
import Select from 'react-select';
import {DonorTypes, Group} from "../types";
import GroupManager from "../GroupManager";
import LookupUrl from "./LookupUrl";

interface GroupSelectorProps {
    donorType: DonorTypes;
    selectedGroup: Group | null;
    groupOptions: Array<{value: Group, label: string}>;
    onGroupChange: (group: Group | null) => void;
}

const GroupSelector: React.FC<GroupSelectorProps> = ({
    donorType,
    selectedGroup,
    groupOptions,
    onGroupChange
}) => {
    return (
        <div>
            <label htmlFor="group-id-input" className="block font-medium text-gray-700">
                {donorType} Number
            </label>
            <Select
                inputId="group-id-input"
                options={groupOptions}
                value={selectedGroup ? {
                    value: selectedGroup,
                    label: GroupManager.getOptionText(selectedGroup)
                } : null}
                onChange={(option) => onGroupChange(option ? option.value : null)}
                placeholder={`Search for your ${donorType.toLowerCase()}...`}
                isClearable
                className="mt-1"
                styles={{
                    control: (base) => ({
                        ...base,
                        boxShadow: 'none',
                    }),
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? '#f3f4f6' : 'white',
                        color: 'black',
                        ':active': {
                            backgroundColor: '#f3f4f6',
                        },
                        fontSize: '0.875rem',
                        paddingTop: '0.7rem',
                        paddingBottom: '0.7rem',
                        lineHeight: '1.25rem',
                        borderBottom: '1px solid #e2e8f0',
                    }),
                    menuList: (base) => ({
                        ...base,
                        '& > div:last-child': {
                            borderBottom: 'none'
                        },
                    }),
                    menuPortal: base => ({...base, zIndex: 9999})
                }}
            />
            <div className="block text-xs mt-2 text-gray-500 underline">
                <LookupUrl donorType={donorType}/>
            </div>
        </div>
    );
};

export default GroupSelector;
